import { getAuthHeader } from "./authService";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/notificaciones`;
export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";

/* ===== Helpers ===== */
const toJson = (res) => res.json().catch(() => ({}));
const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};
const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

export async function getNotificaciones() {
  const res = await fetch(`${BASE_URL}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

export async function createNotificacion(notificacion) {
  try {
    const payload = clean({
      ...notificacion,
      institucion_id: INSTITUCION_ID,
    });
    const res = await fetch(`${BASE_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? data;
  } catch (error) {
    return { error: error.message || "Error al crear la notificación" };
  }
}

export async function deleteNotificacion(id) {
  try {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        ...getAuthHeader(),
      },
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? data;
  } catch (error) {
    return { error: error.message || "Error al enviar la notificación" };
  }
}

export async function sendNotification(id) {
  // TO DO: Implementar el envio de notificacion
  try {
    const res = await fetch(`${BASE_URL}/enviar/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...getAuthHeader(),
      },
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? data;
  } catch (error) {
    return { error: error.message || "Error al enviar la notificación" };
  }
}